import * as React from 'react';

const SvgIconArrowLeft = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} fill="none" {...props}>
    <path
      d="M23.25 12H.75M11.25 1.5L.75 12l10.5 10.5"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgIconArrowLeft;
